<div class="di-confirmation-suppression">
	<div class="dialog-content">
		<lua-action-secondaire [libelle]="'OUI, supprimer'" [color]="'CouleurPrimaire'" [fullWidth]="true"
			[avecIcone]="false" [size]="'medium'" [isDisabled]="false" [positionIcone]="'L'"
			(click)="onConfirm()"></lua-action-secondaire>
		<lua-bouton-texte [libelle]="'NON, annuler'" [color]="'CouleurPrimaire'" [fullWidth]="true" [isDisabled]="false"
			[endIcon]="''" [type]="'button'" [size]="'medium'" (click)="onCancel()"></lua-bouton-texte>
	</div>
</div>